module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//box.png?v=d72b9ce1";